'use-client';
import React from 'react';
import classNames from 'clsx';
import type { SkinFiveGridLineProps } from '../SkinFiveGridLine';
import { FiveGridLineWrapper } from '../../FiveGridLineWrapper';
import skinsStyle from './FadeLine.scss';

const FadeLine: React.FC<SkinFiveGridLineProps> = wrapperProps => {
  return (
    <FiveGridLineWrapper
      {...wrapperProps}
      className={classNames(wrapperProps.className, skinsStyle.root)}
    >
      <div className={skinsStyle.line} />
    </FiveGridLineWrapper>
  );
};

export default FadeLine;
